





import settings from '@/settings.coffee'
import ImageUploader from '@/components/ImageUploader.vue'

export default {
    "name": "ImageListUploader"
    "props": {
        "infos": Array
        "params":Object
    }
    "components": {ImageUploader}
}
